import { useEffect } from "react";
import {
  animate,
  motion,
  useMotionTemplate,
  useMotionValue,
  useReducedMotion,
} from "framer-motion";

export default function HeroLogo() {
  const reduced = useReducedMotion();
  const sweep = useMotionValue(reduced ? 360 : 0);
  const mask = useMotionTemplate`conic-gradient(from 62deg, #000 ${sweep}deg, transparent 0)`;

  useEffect(() => {
    if (reduced) return;
    const controls = animate(sweep, 360, {
      duration: 1.7,
      delay: 0.9,
      ease: [0.65, 0, 0.35, 1],
    });
    return () => controls.stop();
  }, [reduced, sweep]);

  return (
    <motion.div
      data-testid="hero-logo-float"
      animate={reduced ? undefined : { y: [0, -10, 0] }}
      transition={{ duration: 5.5, delay: 2.6, repeat: Infinity, ease: "easeInOut" }}
      className="p-8 sm:p-10"
    >
      <motion.img
        data-testid="hero-brand-logo"
        src="/saath-logo.png"
        alt="SAATH Trainings logo"
        style={{ WebkitMaskImage: mask, maskImage: mask }}
        className="aspect-square w-full object-contain"
      />
    </motion.div>
  );
}
